import $ from 'jquery';

function useProgressBar() {
    const article = document.getElementsByTagName('article')[0];
    const progressContainer = document.getElementById('progress-container');
    const progressSlider = document.getElementById('progress-slider');
    const progressPercent = document.getElementById('progress-percent');
    const articleHeight = article.offsetHeight;
    let progress = '';

    window.addEventListener('scroll', () => {
        const whereInArticle = window.scrollY;
        const viewportHeight = window.innerHeight / 2;
        progress = Math.round((whereInArticle / (articleHeight - viewportHeight)) * 100);
        const percentTextWidth = progressPercent.offsetWidth;
        const progressInPx = (progress / 100) * progressContainer.offsetWidth;
        const marginCalculation = Math.round(progressInPx - (percentTextWidth + 2));
        const marginLeft = Math.max(6, marginCalculation);
        const progressString = `${progress}%`;
        progressPercent.innerText = progressString;
        progressSlider.style.width = progressString;
        progressPercent.style['margin-left'] = `${marginLeft}px`;
        if (progress < 0 || progress > 100) {
            progressContainer.classList.add('hidden');
        } else {
            progressContainer.classList.remove('hidden');
        }
    });
}

if ($('.progress-container')[0]) {
    $('document').ready(useProgressBar);
}
